import { ChainId } from '@pancakeswap/chains'
import { useMemo } from 'react'
import { createPortal } from 'react-dom'

import { useActiveChainId } from 'hooks/useActiveChainId'
import { V3_SUBGRAPH_URLS, GRAPH_API_LOTTERY, GRAPH_API_PREDICTION_BNB } from 'config/constants/endpoints'

import { SubgraphHealthIndicator, SubgraphHealthIndicatorProps } from './SubgraphHealthIndicator'

interface FactoryParams {
  getSubgraphUrl: (chainId: ChainId) => string | undefined
}

type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>
type PartialBy<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>

export function subgraphHealthIndicatorFactory({ getSubgraphUrl }: FactoryParams) {
  return function Indicator(props: PartialBy<SubgraphHealthIndicatorProps, 'subgraphUrl'>) {
    const { chainId } = useActiveChainId()
    const subgraphUrl = useMemo(() => getSubgraphUrl(chainId), [chainId])

    return createPortal(<SubgraphHealthIndicator subgraphUrl={subgraphUrl} {...props} />, document.body)
  }
}

// Previously this returned a subgraph *name*, and only for `api.thegraph.com` hosted
// URLs -- which meant it resolved to '' on PulseChain and the indicator never ran.
// The health hook now takes the subgraph URL directly, so pass it through as-is.
export const V3SubgraphHealthIndicator = subgraphHealthIndicatorFactory({
  getSubgraphUrl: (chainId) => V3_SUBGRAPH_URLS[chainId],
})

export const LotterySubgraphHealthIndicator = subgraphHealthIndicatorFactory({
  getSubgraphUrl: () => GRAPH_API_LOTTERY,
})

export const PredictionSubgraphHealthIndicator = subgraphHealthIndicatorFactory({
  getSubgraphUrl: () => GRAPH_API_PREDICTION_BNB,
})
